import { BaseEditItemStore } from "@leap4/frontend";
import { IAdvertiserLogins } from "../../interfaces/IAdvertiserLogins";

export class EditAdvertiserLoginsStore extends BaseEditItemStore<IAdvertiserLogins> {
    entityName: string = "Advertiser Login";
}
